import type {NaiveDateTimeObj} from './types';

import {ISOStringToDatetimeObj} from './ISOStringToDatetimeObj';

export const ISOStringToNaiveDatetimeObj = (
  ISOString: string,
): NaiveDateTimeObj => ({
  ...ISOStringToDatetimeObj(ISOString),
  utcoffset: null,
});
